import getEnvironmentConfig from './environment'

class Kiosk {
	async getDeviceDetails() {
		return await getEnvironmentConfig()
	}
}

export default new Kiosk()
